import { provide } from 'vue'
import { Step } from '../../domain'

export const logisticFormStepsSymbol = Symbol('logisticFormSteps')

export const provideLogisticOfferFormSteps = (steps: Step[]) => {
  provide(logisticFormStepsSymbol, steps)
}
